import React, { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";

const AdminGalleryAwards = () => {
  const [form, setForm] = useState({
    name: "",
    image: null,
  });

  const [data, setData] = useState([]);

  // FETCH DATA
  const fetchData = () => {
    fetch(" https://node.ilakshyaerp.in/api/galleryAwards")
      .then((res) => res.json())
      .then((resData) => setData(Array.isArray(resData) ? resData : []))
      .catch(() => console.log("Fetch error"));
  };

  useEffect(() => {
    fetchData();
  }, []);

  // SUBMIT
  const handleSubmit = async () => {
    // 🔴 VALIDATION
    if (!form.name) {
      alert("Please enter name");
      return;
    }

    if (!form.image) {
      alert("Please select image");
      return;
    }

    // 🔴 FILE SIZE CHECK (10MB)
    if (form.image.size > 10 * 1024 * 1024) {
      alert("File size must be less than 10MB ❌");
      return;
    }

    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("image", form.image);

    try {
      const res = await fetch(" https://node.ilakshyaerp.in/api/galleryAwards/add", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      // 🔴 BACKEND ERROR
      if (!res.ok) {
        alert(data.message || "Upload failed ❌");
        return;
      }

      // ✅ SUCCESS
      alert("Gallery & Awards added successfully ✅");

      setForm({ name: "", image: null });
      fetchData();

    } catch (err) {
      alert("Server error ❌");
    }
  };

  // DELETE
  const handleDelete = (id) => {
    fetch(` https://node.ilakshyaerp.in/api/galleryAwards/${id}`, {
      method: "DELETE",
    }).then(fetchData);
  };

  return (
    <AdminLayout>
      <div className="notice-page">

        {/* FORM */}
        <div className="notice-card">
          <h2>Add Gallery and Awards</h2>

          <input
            placeholder="Enter Name"
            value={form.name}
            onChange={(e) =>
              setForm({ ...form, name: e.target.value })
            }
          />

          <input
            type="file"
            accept=".jpg,.jpeg,.png"
            onChange={(e) =>
              setForm({ ...form, image: e.target.files[0] })
            }
          />

          <button onClick={handleSubmit}>Add</button>
        </div>

        {/* TABLE */}
        <div className="notice-table">
          <h2>Gallery & Awards</h2>

          <table>
            <tbody>
              {data.length > 0 ? (
                data.map((d) => (
                  <tr key={d.id}>
                    <td>
                      <img
                        src={` https://node.ilakshyaerp.in/uploads/galleryAwards/${d.image}`}
                        width="80"
                        alt="gallery"
                      />
                    </td>
                    <td>{d.name}</td>
                    <td>
                      <button
                        className="delete-btn"
                        onClick={() => handleDelete(d.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }}>
                    No Gallery & Awards data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>

        </div>

      </div>
    </AdminLayout>
  );
};

export default AdminGalleryAwards;